// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3g2K7","title":"Info_title__3MDb5","links":"Info_links__T6jEX","link":"Info_link__3EKct","logo":"Info_logo__1nEuu"};